// Ingombro, misurato dal fondo della finestra, degli elementi fissi in basso a destra (notifica di aggiornamento,
// pulsante di emulazione): il deck degli alert si alza sopra di loro
class BottomRightCorner {
  private readonly occupants = new Map<Element, number>()
  private readonly listeners = new Set<() => void>()
  private top = 0

  subscribe = (listener: () => void) => {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  getTop = () => this.top

  // usabile come ref callback: misura l'elemento finché resta montato
  track = (element: HTMLElement | null) => {
    if (!element) return undefined
    const observer = new ResizeObserver(() => {
      this.occupants.set(element, window.innerHeight - element.getBoundingClientRect().top)
      this.update()
    })
    observer.observe(element)
    return () => {
      observer.disconnect()
      this.occupants.delete(element)
      this.update()
    }
  }

  private update() {
    const top = Math.max(0, ...this.occupants.values())
    if (top === this.top) return
    this.top = top
    this.listeners.forEach((listener) => listener())
  }
}

export default new BottomRightCorner()
